<!-- eslint-disable vue/no-mutating-props -->
<template>
  <modal
    :show.sync="show"
    :on-close="onClose"
    :size="v2 ? 'modal-v2 modal-v2--sm' : ''"
  >
    <woot-modal-header-v2
      :header-title="title"
      :header-title-icon="'delete'"
      :has-shadow="!v2"
    />
    <slot name="additionInfo" />
    <div class="px-6 text-gray-600">
      <span>{{ message }}</span>
      <span class="font-semibold" v-text="messageValue" /><span
        v-text="messageSuffix"
      />
    </div>
    <div
      class="delete-item px-6 pb-6 pt-[28px] flex flex-row justify-end gap-3"
    >
      <woot-button
        class="button clear text-base px-5 py-3 leading-[20px] h-[48px] font-[400]"
        :class="{ '!text-[#374151]': v2 }"
        color-scheme="secondary"
        @click.prevent="onClose"
      >
        {{ rejectText }}
      </woot-button>
      <woot-button
        color-scheme=""
        :is-loading="isLoading"
        class="button-filled text-base px-5 py-3 font-[400] h-[48px] btn-delete"
        @click.prevent="onConfirm"
      >
        {{ confirmText }}
      </woot-button>
    </div>
  </modal>
</template>

<script>
import Modal from '../../Modal.vue';

export default {
  components: {
    Modal,
  },
  props: {
    show: Boolean,
    onClose: { type: Function, default: () => {} },
    onConfirm: { type: Function, default: () => {} },
    title: { type: String, default: '' },
    message: { type: String, default: '' },
    messageValue: { type: String, default: '' },
    messageSuffix: { type: String, default: '' },
    confirmText: { type: String, default: '' },
    rejectText: { type: String, default: '' },
    isLoading: { type: Boolean, default: false },
    v2: { type: Boolean, default: false },
  },
};
</script>
<style lang="scss" scoped>
::v-deep {
  .modal-container {
    @apply rounded-[12px];
  }
}
.action-button {
  max-width: var(--space-giga);
}
</style>
